import React from 'react';


const Loader = props => {
	
	return (
	
		<div className={props?.small ? 'spinner-border spinner-border-sm' : 'spinner-border'} style={{color: props.color}} role="status">
			<span className="sr-only">Loading...</span>
		</div>

	)
}
	

export default Loader;
